import { render, staticRenderFns } from "./AdminCreateCompany.vue?vue&type=template&id=5166d80a&scoped=true"
import script from "./AdminCreateCompany.vue?vue&type=script&lang=js"
export * from "./AdminCreateCompany.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateCompany.vue?vue&type=style&index=0&id=5166d80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5166d80a",
  null
  
)

export default component.exports